import { module } from 'angular';

import { default as radioButtonDirectiveName, RadioButtonDirective } from './radio-button.directive';

export default module('contact.commons.toolbox.radio-button', []).directive(radioButtonDirectiveName, RadioButtonDirective).name;
